import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  TextField,
  Button,
  Box,
  Typography,
  styled,
  makeStyles,
  ButtonGroup,
  RadioGroup,
  Radio,
  FormControlLabel,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import UploadVideo from "./UploadVideo";
import { toast } from "react-toastify";
import IOSSwitch from "../../formComponents/IOSSwitch";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockIcon from "@mui/icons-material/Lock";
import VisbilityConfirm from "../../../Modals/user/visibilityInfo/Modal";

const CustomTextarea = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #46496a",
    borderRadius: "8px",
    color: "white",
    padding: "10px 15px",

    [theme.breakpoints.down("md")]: {
      padding: "8px 11px",
      fontSize: "14px",
    },

    "& .MuiInputBase-input": {
      // maxHeight: "70px",
      [theme.breakpoints.down("md")]: {
        maxHeight: "52px",

        padding: "0px",
      },
      "&.Mui-disabled": {
        // backgroundColor: "rgba(255,255,255,0.04) !important",
        // border: "1px solid #2f3250 !important",
        // color: "rgba(255,255,255,0.4) !important",
        // color: "rgba(255,255,255,0.4) !important",
        WebkitTextFillColor: "inherit",
        cursor: "not-allowed !important",
      },
    },
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #46496a",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #46496a",
      outline: "none",
    },

    "&.Mui-disabled": {
      backgroundColor: "rgba(255,255,255,0.04) !important",
      border: "1px solid #2f3250 !important",
      color: "rgba(255,255,255,0.4) !important",
      // color: "rgba(255,255,255,0.4) !important",
      WebkitTextFillColor: "inherit",
      cursor: "not-allowed !important",
    },
  },

  "& .MuiInputBase-input": {
    padding: "0",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const StyledRadioLable = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== "checked",
})(({ theme, checked, disabled }) => ({
  gap: "10px",
  alignItems: "center",
  margin: theme.spacing(1),
  padding: "15px 20px",
  borderRadius: "40px",

  cursor: disabled ? "not-allowed !important" : "pointer !important",

  backgroundColor: disabled
    ? checked
      ? "rgba(255,205,31,0.4)"
      : "#2a2d4a"
    : checked
      ? "#FFCD1F"
      : "#343759",

  color: disabled
    ? checked
      ? "rgba(0,0,0,0.6)"
      : "rgba(255,255,255,0.4)"
    : checked
      ? "black"
      : "#ffffff",
  padding: "15px 20px",
  [theme.breakpoints.down("md")]: {
    padding: "8px 11px",
    fontSize: "14px",
  },

  textTransform: "none",

  "& .Mui-checked ": {
    backgroundColor: "#FFCD1F",
    color: "black",
  },

  "& .MuiFormControlLabel-label": {
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
  },
}));

const StyledRadioD = styled(Radio)(({ theme }) => ({
  display: "none",
}));

const Form = ({
  data,
  setGoalVideos,
  index,
  setDeletedVideos,
  goalVideos,
  addTournamentFormSubmited,
  isAdmin,
}) => {
  const mounted = useRef(false);
  const userData = useSelector((state) => state.user);
  const [goalVisModal, setGoalVisModal] = useState(false);

  const Admin_user_cond =
    !isAdmin &&
    goalVideos[index]?.user_id &&
    goalVideos[index].user_id !== userData.data.id;


  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          className="goal-seperate-form"
          sx={{ border: "1px solid #46496a", gap: "20px" }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              flexDirection: { xs: "column", md: "row", lg: "row" },
            }}
          >
            <Box className="category form-control">
              <Typography className="label">Goal Scorer</Typography>
              <CustomTextarea
                variant="outlined"
                name="goal_scorer"
                value={goalVideos[index].goal_scorer}
                onChange={(e) => {
                  setGoalVideos((prev) =>
                    prev.map((p, i) =>
                      i == index
                        ? { ...p, goal_scorer: e.target.value, edited: true }
                        : { ...p },
                    ),
                  );
                }}
                disabled={Admin_user_cond}
                placeholder="Enter Goal Scorer"
              />
              {!goalVideos[index].goal_scorer && addTournamentFormSubmited ? (
                <FormHelperText sx={{ color: "red" }}>
                  Please enter the goal scorer.
                </FormHelperText>
              ) : (
                ""
              )}
            </Box>
            <Box className="category form-control">
              <Typography className="label">Visibility</Typography>

              <RadioGroup name="from_uk" row>
                {[
                  {
                    name: "Public",
                    id: 1,
                    icon: <LockOpenIcon sx={{ fontSize: "20px" }} />,
                  },
                  {
                    name: "Private",
                    id: 0,
                    icon: <LockIcon sx={{ fontSize: "20px" }} />,
                  },
                ].map((category) => (
                  <StyledRadioLable
                    control={
                      <>
                        {category.icon}
                        <StyledRadioD
                          value={category.id}
                          checked={goalVideos[index].visibility == category.id}
                        />
                      </>
                    }
                    label={category.name}
                    checked={goalVideos[index].visibility == category.id}
                    key={category.id}
                    onClick={() => {
                      if (!Admin_user_cond) {
                        if (category.id == 0) {
                          setGoalVisModal(true);
                        }
                        setGoalVideos((prev) =>
                          prev.map((p, i) =>
                            i == index
                              ? {
                                  ...p,
                                  visibility: category.id == 1 ? true : false,
                                  edited: true,
                                }
                              : { ...p },
                          ),
                        );
                      }
                    }}
                    disabled={Admin_user_cond}
                  />
                ))}
              </RadioGroup>
            </Box>
          </Box>

          <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
            <Box className="category form-control">
              <UploadVideo
                setGoalVideos={setGoalVideos}
                index={index}
                goalVideos={goalVideos}
                Admin_user_cond={Admin_user_cond}
              />
              {!goalVideos[index].goal && addTournamentFormSubmited ? (
                <FormHelperText sx={{ color: "red" }}>
                  Please upload the goal video.
                </FormHelperText>
              ) : (
                ""
              )}
            </Box>
            {index == 0 && goalVideos.length == 1 ? null : (
              <Box sx={{ display: "flex", gap: "5px" }}>
                <Box>
                  <Button
                    sx={{
                      border: "1px solid #46496a",
                      borderRadius: "8px",
                      padding: "8px 13px",
                      marginTop: "20px",

                      color: "#ef364e",

                      cursor: Admin_user_cond
                        ? "not-allowed !important"
                        : "pointer !important",

                      "&.Mui-disabled": {
                        color: "#ef364e", // override default grey
                        opacity: 0.5, // optional
                        border: "1px solid #46496a",
                        cursor: "not-allowed !important",
                      },

                      "&:hover": {
                        border: "1px solid #46496a",
                        backgroundColor: "transparent",
                      },
                    }}
                    onClick={() => {
                      if (goalVideos.length <= 1) {
                        toast.error(
                          "Please enter at least on Internation Tournament video.",
                        );
                        return;
                      }
                      goalVideos.map((goal, i) => {
                        if (i == index && goal.id) {
                          setDeletedVideos((del) => [...del, goal.id]);
                        }
                      });
                      setGoalVideos((prev) =>
                        prev.filter((state, i) => {
                          if (i == index) {
                            return false;
                          } else {
                            return true;
                          }
                        }),
                      );
                    }}
                    disabled={Admin_user_cond}
                  >
                    Remove
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        </Box>

        {data?.error && addTournamentFormSubmited && (
          <Box sx={{ width: "100%" }}>
            <FormHelperText sx={{ color: "red" }}>{data.error}</FormHelperText>
          </Box>
        )}
      </Box>
      <VisbilityConfirm open={goalVisModal} setOpen={setGoalVisModal} />
    </>
  );
};

export default Form;
